  document.querySelectorAll('[data-popup-close]').forEach(function(value){
    value.addEventListener('click',function(event){
      event.preventDefault();
      this.closest('[data-popup]').classList.remove('open');
    });
  });

  document.querySelectorAll('[data-popup-open]').forEach(function(value){
    value.addEventListener('click',function(event){
      event.preventDefault();
      var popup = this.getAttribute('data-popup-open');
      var $popup = document.querySelector('[data-popup="'+ popup +'"');
      $popup.classList.add('open');
    });
  });